import { useLocation } from 'react-router-dom';
import { Flex, useToast } from '@chakra-ui/react';
import { useEffect } from 'react';
import axios from 'axios';
import ProductDetailsData from './components/ProductDetailsData';
import { ProductDetailsInfo } from './components/ProductDetailsInfo';
import { useProduct } from '../../../../../../hooks/product';
import { translateError } from '../../../../../../utils/errors';
import { DefaultLayout } from '../../../../_layout/DefaultLayout';
import { showProductsService } from '../../../../../../services/Products/ShowProductsService';

interface ILocationState {
  productId: string;
}

export const ProductDetails = (): JSX.Element => {
  const toast = useToast();
  const { handleProduct, product } = useProduct();

  const {
    state: { productId },
  } = useLocation<ILocationState>();

  useEffect(() => {
    async function loadProduct(id: string): Promise<void> {
      try {
        const productData = await showProductsService(id);

        handleProduct(productData);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status !== 401) {
          toast({
            title: 'Falha ao carregar dados',
            description:
              translateError({ message: err.response?.data.message }) ||
              'Ocorreu um erro ao carregar os detalhes do produto, tente novamente.',
            status: 'error',
            duration: 3000,
            isClosable: true,
            variant: 'subtle',
            position: 'top-right',
          });
        }
      }
    }

    loadProduct(productId);

    return () => handleProduct(undefined);
  }, [productId, handleProduct, toast]);

  return (
    <DefaultLayout>
      {product && (
        <Flex direction="column" w="100%">
          <ProductDetailsInfo minW="510px" />

          <ProductDetailsData flex="1" mt="8" minW="510px" />
        </Flex>
      )}
    </DefaultLayout>
  );
};
